export default __webpack_public_path__ + "static/media/icon_3_0.4dee880c.svg";